import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import { css } from 'styled-components';

var PrimaryButtonStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: #fff;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n"], ["\n  background-color: ", ";\n  color: #fff;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryLighten;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDarken;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDisabled;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && "background-color: " + theme.colors.primaryDisabled + ";";
});
var SecondaryButtonStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray2;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.gray4 : theme.colors.gray6;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray3;
});
var DangerButtonStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  color: #fff;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n"], ["\n  background-color: ", ";\n  color: #fff;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.danger;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dangerLighten;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dangerDarken;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.dangerDisabled;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && "background-color: " + theme.colors.dangerDisabled + ";";
});
var GhostButtonStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 2px solid #fff;\n  background-color: transparent;\n  color: #fff;\n\n  :hover {\n    background-color: rgba(255, 255, 255, 0.15);\n  }\n\n  :active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n"], ["\n  border: 2px solid #fff;\n  background-color: transparent;\n  color: #fff;\n\n  :hover {\n    background-color: rgba(255, 255, 255, 0.15);\n  }\n\n  :active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n"])));
var OutlineButtonStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n\n  :hover,\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n\n  :active {\n    background-color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n\n  :hover,\n  :disabled {\n    background-color: ", ";\n  }\n  ", "\n\n  :active {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray3;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.gray4 : theme.colors.gray6;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray1;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && "background-color: " + theme.colors.gray1 + ";";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray2;
});
var LinkButtonStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0;\n  font-size: 1.6rem;\n  color: ", ";\n  text-decoration: none;\n\n  :hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  :active {\n    color: ", ";\n  }\n"], ["\n  padding: 0;\n  font-size: 1.6rem;\n  color: ", ";\n  text-decoration: none;\n\n  :hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  :active {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryLighten;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryDarken;
});
var AnchorStyle = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var PillButtonStyle = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 12.2rem;\n  height: 3.7rem;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10rem;\n  text-decoration: none;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    color: ", ";\n  }\n  ", "\n"], ["\n  width: 12.2rem;\n  height: 3.7rem;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10rem;\n  text-decoration: none;\n\n  :hover {\n    background-color: ", ";\n  }\n\n  :active {\n    background-color: ", ";\n  }\n\n  :disabled {\n    color: ", ";\n  }\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray6;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray3;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray4;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled && "color: " + theme.colors.gray4 + ";";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

export { AnchorStyle, DangerButtonStyle, GhostButtonStyle, LinkButtonStyle, OutlineButtonStyle, PillButtonStyle, PrimaryButtonStyle, SecondaryButtonStyle };
